import React from 'react';
const tones = ['bg-night', 'bg-court-deep', 'bg-green-deep', 'bg-sky-deep', 'bg-court'];

/** Fallback bonus cover, shown while no mockup image URL is set. */
export function BonusArt({
  number,
  title,
  index
}: {
  number: string;
  title: string;
  index: number;
}) {
  const short = title.split(':')[0];
  const sub = title.includes(':') ? title.split(':').slice(1).join(':').trim() : '';
  return <div className={`relative flex h-[230px] w-full items-center justify-center overflow-hidden sm:h-[265px] ${tones[index % tones.length]}`} role="img" aria-label={`${title} cover`} data-id="element-23" data-mp="2leewd32garb6">
      <svg viewBox="0 0 400 260" className="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice" aria-hidden="true" data-id="element-24" data-mp="2bnai65klnahe">
        <g fill="none" stroke="#FFFDF8" strokeOpacity="0.2" strokeWidth="2" data-id="element-25" data-mp="26ofyz2ipzjwr">
          <circle cx="320" cy="60" r="70" data-id="element-26" data-mp="345eoue95mj97" />
          <path d="M-10 230 C 90 200, 80 90, 200 90 S 330 30, 410 10" strokeDasharray="2 9" strokeLinecap="round" strokeWidth="3" data-id="element-27" data-mp="3467pqylfmejf" />
        </g>
        {[0, 60, 120, 180, 240, 300].map(a => {
        const r = a * Math.PI / 180;
        return <circle key={a} cx={320 + Math.cos(r) * 70} cy={60 + Math.sin(r) * 70} r="6" fill="#FFFDF8" fillOpacity="0.25" data-id="element-28" data-mp="19cybg5b1d18i" />;
      })}
      </svg>
      <div className="relative w-[68%] max-w-[250px] -rotate-3 rounded-2xl bg-white p-4 shadow-card" data-id="element-29" data-mp="unio6zaprdxk">
        <span className="block text-[10px] font-bold uppercase tracking-widest text-court-deep" data-id="element-30" data-mp="zksjuwop4ltu">Bonus {number}</span>
        <span className="mt-1.5 block font-display text-[17px] font-bold leading-snug text-ink" data-id="element-31" data-mp="popiht1o4r7y">{short}</span>
        {sub && <span className="mt-1 block text-[11px] leading-snug text-ink-soft" data-id="element-32" data-mp="bpg2ouhdjz4i">{sub}</span>}
        <span className="mt-3 inline-block h-2 w-10 rounded-full bg-shuttle" data-id="element-33" data-mp="gnrcj57o69mq" />
      </div>
    </div>;
}